module.exports = __webpack_public_path__ + "static/media/rightBlack.91fac89b.svg";